import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { SentryService } from './sentry.service';

@Injectable()
export class SentryHttpInterceptor implements HttpInterceptor {
  private readonly sentryService = inject(SentryService);

  intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    return next.handle(req).pipe(
      catchError((error: HttpErrorResponse) => {
        this.sentryService.captureHttpError(
          {
            status: error.status,
            statusText: error.statusText,
            message: error.message
          },
          {
            url: req.url,
            method: req.method
          }
        );

        return throwError(() => error);
      })
    );
  }
}
